import giftCards from '../../images/GIftCard-Placeholder.webp';

const GIFT_CARDS = [
    {
        img : giftCards,
        title : '$10 Gift Card',
        key : 1
    },
    {
        img : giftCards,
        title : '$25 Gift Card',
        key : 2
    },
    {
        img : giftCards,
        title : '$50 Gift Card',
        key : 3
    },
    {
        img : giftCards,
        title : '$100 Gift Card',
        key : 4
    }
]

export default GIFT_CARDS;